module.exports = __webpack_public_path__ + "img/icon_sm_sycb.d094efde.png";